import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system'

const baseStyle = defineStyle({
  color: 'blue.500',
})

export const linkTheme = defineStyleConfig({
  baseStyle,
})
